<div class="navbar">
    <div>
        <img src="../../../assets/vectors/Help Desk Icon.svg" class="navbar-icon" alt="Help Desk Icon">
        <img src="../../../assets/vectors/Line 95.svg" class="navbar-line-margin" alt="">
        <span class="dashboard-span">Dashboard / </span>
        <span class="helpdesk-span" (click)="navigate('Help Desk')">Help Desk / </span>
        <span class="ticket-details-span">Ticket Details</span>
    </div>

    <div class="flex-container">
        @if (ticketDetails.ticket_status === 'Resolved') {
        <div class="flex-container-sub-div-one">
            <span class="ticket-status">Ticket Status:<span>{{ ticketDetails.ticket_status
                    }}</span></span>
            <div class="ticket-status-popup">
                <button class="reopen-tiket-btn" (click)="reopenTicket()"
                    *ngIf="ticketDetails.ticket_status === 'Resolved'">
                    <svg width="3" height="13" viewBox="0 0 3 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="1.5" cy="1.5" r="1.5" fill="#666666" />
                        <circle cx="1.5" cy="6.5" r="1.5" fill="#666666" />
                        <circle cx="1.5" cy="11.5" r="1.5" fill="#666666" />
                    </svg>
                </button>

                <div class="reponen-ticket" *ngIf="reopenTicketPopup">
                    <button (click)="changeTicketStatus(ticketDetails.ticket_id)">Reopen Ticket</button>
                </div>
            </div>
        </div>
        } @else {
        <div class="flex-container-sub-div-two">
            <span class="ticket-status">Ticket Status:<span>{{ ticketDetails.ticket_status
                    }}</span></span>
            <div class="ticket-status-popup">
                <button class="reopen-tiket-btn" (click)="reopenTicket()"
                    *ngIf="ticketDetails.ticket_status === 'Resolved'">
                    <svg width="3" height="13" viewBox="0 0 3 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="1.5" cy="1.5" r="1.5" fill="#666666" />
                        <circle cx="1.5" cy="6.5" r="1.5" fill="#666666" />
                        <circle cx="1.5" cy="11.5" r="1.5" fill="#666666" />
                    </svg>
                </button>

                <div class="reponen-ticket" *ngIf="reopenTicketPopup">
                    <button (click)="changeTicketStatus(ticketDetails.ticket_id)">Reopen Ticket</button>
                </div>
            </div>
        </div>
        }
    </div>

    <img src="../../../assets/vectors/Line 96.svg" class="margin-x-16" alt="">

    <div class="logout-btn-container">
        <button class="logout-btn-container-icon-btn" (click)="openLogOutComponent()">
            <span>
                <img src="../../../assets/vectors/Profile Icon.svg" alt="Profile Icon">
            </span>
        </button>

        <div *ngIf="openLogoutPopup" class="log-out-popup">
            <div class="log-out-popup-username-div">
                <span>{{ userName }}</span>
            </div>
            <div>
                <button class="log-out-popup-logout-btn" (click)="logout()">
                    <img src="../../../assets/vectors/material-symbols_logout.svg" alt="Logout"> Logout
                </button>
            </div>
        </div>
    </div>
</div>



<div class="ticket-details-header-container">
    <button class="back-img" (click)="navigate('Help Desk')"><img src="../../../assets/vectors/back.svg"
            alt=""></button>
    <div class="ticket-details">
        <div class="ticket-details-sub-div-one">
            <div class="ticket-details-sub-div-one-sub-div-one">
                <span># {{ ticketDetails.ticket_id }}</span>
            </div>
            <span><img src="../../../assets/vectors/Line 96.svg" alt="" class="margin-x-24px"></span>

            <div class="ticket-details-sub-div-one-sub-div-two">
                <span class="ticket-name" title="{{ticketDetails.email_subject}}">{{ ticketDetails.email_subject
                    }}</span>
            </div>

        </div>
        <div class="position-relative">
            <button class="add-participants-btn" (click)="openAddParticipantsPopup()">
                <span>
                    <img src="../../../assets/vectors/Group 1233.svg" alt="">
                </span>
                Add Participants
            </button>


            <div *ngIf="addParticipantsPopup" class="add-participants-container">
                <form #form="ngForm" (submit)="addParticipants()">
                    <div class="participants-form-wrapper">
                        <textarea name="participants"
                            class="participants-textarea-input"
                            placeholder="Add emails of the participants separated by semicolon"
                            [(ngModel)]="participants">
                        </textarea>
                        <p *ngIf="participantsErrorMessage"
                            class="participants-error-message">*{{
                            participantsErrorMessage }}</p>

                    </div>
                    <div class="participants-form-button-wrapper">
                        <button class="participants-form-submit-button" type="submit">Add</button>
                    </div>
                </form>

                <div class="participants-list-container">
                    <span class="participants-list-title">{{`Participants
                        (${participantsList.length})`}}</span>
                    <div class="participant-item-wrapper">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="20" cy="20" r="20" fill="#E6E6E6" />
                            <rect width="21.6949" height="21.6949" transform="translate(9.49219 9.49121)"
                                fill="#E6E6E6" />
                            <path
                                d="M14.1684 23.205C13.4903 23.8831 13.1094 24.8028 13.1094 25.7618V27.5697H27.5727V25.7618C27.5727 24.8028 27.1917 23.8831 26.5136 23.205C25.8355 22.5269 24.9158 22.146 23.9568 22.146C22.9979 22.146 21.7828 22.5893 20.3721 22.5922C18.9373 22.5952 17.6842 22.146 16.7252 22.146C15.7662 22.146 14.8465 22.5269 14.1684 23.205Z"
                                stroke="black" stroke-width="1.35593" stroke-linejoin="round" />
                            <path
                                d="M20.3419 18.7819C21.9783 18.7819 23.3048 17.4553 23.3048 15.8189C23.3048 14.1825 21.9783 12.856 20.3419 12.856C18.7055 12.856 17.3789 14.1825 17.3789 15.8189C17.3789 17.4553 18.7055 18.7819 20.3419 18.7819Z"
                                stroke="black" stroke-width="1.48148" />
                        </svg>

                        <div class="participant-item-details">
                            <span class="participant-name">{{ tickerCreatorEA
                                }}</span>
                            <span class="participant-creator-label">Creater</span>
                        </div>
                    </div>

                    @for (participant of participantsList; track $index) {
                    <div class="participant-item-wrapper">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="20" cy="20" r="20" fill="#E6E6E6" />
                            <rect width="21.6949" height="21.6949" transform="translate(9.49219 9.49121)"
                                fill="#E6E6E6" />
                            <path
                                d="M14.1684 23.205C13.4903 23.8831 13.1094 24.8028 13.1094 25.7618V27.5697H27.5727V25.7618C27.5727 24.8028 27.1917 23.8831 26.5136 23.205C25.8355 22.5269 24.9158 22.146 23.9568 22.146C22.9979 22.146 21.7828 22.5893 20.3721 22.5922C18.9373 22.5952 17.6842 22.146 16.7252 22.146C15.7662 22.146 14.8465 22.5269 14.1684 23.205Z"
                                stroke="black" stroke-width="1.35593" stroke-linejoin="round" />
                            <path
                                d="M20.3419 18.7819C21.9783 18.7819 23.3048 17.4553 23.3048 15.8189C23.3048 14.1825 21.9783 12.856 20.3419 12.856C18.7055 12.856 17.3789 14.1825 17.3789 15.8189C17.3789 17.4553 18.7055 18.7819 20.3419 18.7819Z"
                                stroke="black" stroke-width="1.48148" />
                        </svg>
                        <div class="participant-item-details">
                            <span class="participant-name">{{ participant }}</span>
                            <span class="participant-remove-button"
                                (click)="removeParticipantFromList(participant)">Remove</span>
                        </div>
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>

<div>
    <app-message-stack [ticketID]="ticketDetails.ticket_id" [participantsList]="participantsList"></app-message-stack>
</div>

<div *ngIf="reopenTicketResponse" class="error-popup-overlay">
    <div class="error-popup-content">
        {{ reopenTicketResponse }}
        <button type="button" class="error-popup-close" (click)="reopenTicketResponse = ''">&times;</button>
    </div>
</div>